export default __webpack_public_path__ + "static/27457-d77497399d5d07d4fc622e214a8fbfc4.jpg";